import React from "react";
import AssetsBody from "./AssetsBody";
import AssetsFooter from "./AssetsFooter";
import AssetsHeader from "./AssetsHeader";
import { HeaderAssetSection } from "./styles";

const HeaderDeposit = () => {
  return (
    <HeaderAssetSection>
      <AssetsHeader />
      <AssetsBody />
      <AssetsFooter />
    </HeaderAssetSection>
  );
};

export default React.memo(HeaderDeposit)
